import React, { Component } from 'react';
import { Avatar } from '@99designs/common/components/Avatar';
import FavoriteButton from 'components/FavoriteButton';
import { Creator } from 'apps/find-designers/propTypes';
import DesignerBranding from 'apps/find-designers/components/Listing/DesignerBranding';
import { SearchContext } from 'apps/find-designers/components/SearchContext';
import { isContact, userCanFavourite } from 'apps/find-designers/utils/designers';

class FeaturedSearchItem extends Component {
    favoriteButton() {
        const designer = this.props.designer;
        const favoriteUrl = `/profiles/xhr/favorite-designers/${designer.userId}`;

        return (
            <SearchContext.Consumer>
                {context => {
                    if (!userCanFavourite(context.currentUser, designer)) return null;

                    return (
                        <div className="featured-search-item-header__fav">
                            <FavoriteButton
                                isFavorite={designer.flags.includes('IS_FAVORITE')}
                                favoriteUrl={favoriteUrl}
                            />
                        </div>
                    );
                }}
            </SearchContext.Consumer>
        );
    }

    render() {
        const designer = this.props.designer;
        const profileUrl = `/profiles/${designer.userId}`;

        return (
            <div className="featured-search-item">
                <div className="featured-search-item__header">
                    <div className="featured-search-item-header">
                        <div className="featured-search-item-header__avatar">
                            <Avatar
                                user={{
                                    avatarUrl: `/avatars/users/${designer.userId}/64`,
                                    profileUrl: profileUrl,
                                }}
                                variations={['medium']}
                                isOnline={designer.isOnline}
                            />
                        </div>
                        <div className="featured-search-item-header__branding">
                            <DesignerBranding
                                designer={designer}
                                profileUrl={profileUrl}
                                isContact={isContact(designer.flags)}
                            />
                        </div>
                        {this.favoriteButton()}
                    </div>
                </div>
                <a href={profileUrl} className="featured-search-item__gallery">
                    <picture
                        style={{
                            position: 'absolute',
                            display: 'block',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <source
                            srcSet={designer.designs[0].imageSources.largeCrop}
                            type="image/webp"
                        />
                        <source
                            srcSet={designer.designs[0].imageSources.largeCrop}
                            type="image/jpeg"
                            media="(min-width: 600px)"
                        />
                        <img
                            className="mediabox__media"
                            alt={designer.designs[0].title}
                            title={designer.designs[0].description}
                            src={designer.designs[0].imageSources.largeCrop}
                            data-profile-design
                        />
                    </picture>
                </a>
            </div>
        );
    }
}

FeaturedSearchItem.propTypes = {
    designer: Creator.isRequired,
};

export default FeaturedSearchItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FeaturedSearchItem.jsx